import React from 'react'

export type SessionParticipant = {
  name: string
  type: 'group' | 'individual'
  count?: number
}

function getInitials(name: string): string {
  const trimmed = (name ?? '').trim()
  if (!trimmed) return ''
  const parts = trimmed.split(/\s+/)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  const first = parts[0]
  if (first.length >= 2) return first.slice(0, 2).toUpperCase()
  return first.toUpperCase()
}

type SessionParticipantsProps = {
  participants: SessionParticipant[]
}

const SessionParticipants: React.FC<SessionParticipantsProps> = ({ participants }) => {
  const individualPalette = ['#367D7D', '#BF4095', '#CC4D33', '#945EBA']
  const groupColor = '#BED0F4'

  const pickIndividualColor = (name: string): string => {
    const str = (name ?? '').toString()
    if (!str) return individualPalette[0]
    let hash = 0
    for (let i = 0; i < str.length; i++) {
      // simple deterministic hash
      hash = (hash * 31 + str.charCodeAt(i)) >>> 0
    }
    const index = hash % individualPalette.length
    return individualPalette[index]
  }

  return (
    <div className="flex items-center gap-0.5">
      <div className="flex -space-x-2">
        {(() => {
          const visible = participants.slice(0, 5)
          const visibleCount = visible.length
          return visible.map((p, idx) => {
            const zIndexClass = `z-[${visibleCount - idx}]`
            const bgColor = p.type === 'group' ? groupColor : pickIndividualColor(p.name)
            const initials = getInitials(p.name)
            const showCount = p.type === 'group' && typeof p.count === 'number' && p.count > 0
            const initialsClass = `text-xs font-bold ${p.type === 'group' ? '' : 'text-white'}`.trim()
            return (
              <div key={idx} className={`relative ${zIndexClass} flex items-center gap-2`}>
                <div className="relative flex size-8 items-center justify-center rounded-full border border-white" style={{ backgroundColor: bgColor }}>
                  <span className={initialsClass}>{initials}</span>
                  {showCount ? <div className="notification-bottom">{p.count}</div> : null}
                </div>
              </div>
            )
          })
        })()}
      </div>
      {participants.length > 5 ? <p>...</p> : null}
    </div>
  )
}

export default SessionParticipants


